import { Listbox, Transition } from "@headlessui/react";
import { PayoutTokenButton } from "./PayoutTokenButton";
import { Fragment } from "react";
import { CheckIcon } from "@heroicons/react/24/solid";
import { classNames, NATIVE, stringToBlobUrl } from "common";
import { formatUnits } from "ethers/lib/utils";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function PayoutTokenDropdown(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "mt-1 relative col-span-6 sm:col-span-3",
    children: /*#__PURE__*/_jsx(Listbox, {
      value: props.selectedPayoutToken,
      onChange: props.setSelectedPayoutToken,
      children: _ref => {
        var _props$selectedPayout2;
        let {
          open
        } = _ref;
        return /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs("div", {
            className: "mb-2 shadow-sm block rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
            children: [/*#__PURE__*/_jsx(PayoutTokenButton, {
              token: props.payoutTokenOptions.find(t => {
                var _props$selectedPayout;
                return t.address === ((_props$selectedPayout = props.selectedPayoutToken) === null || _props$selectedPayout === void 0 ? void 0 : _props$selectedPayout.address);
              }),
              balance: props.balances && props.balances[((_props$selectedPayout2 = props.selectedPayoutToken) === null || _props$selectedPayout2 === void 0 ? void 0 : _props$selectedPayout2.address.toLowerCase()) || ""],
              balanceWarning: props.balanceWarning
            }), /*#__PURE__*/_jsx(Transition, {
              show: open,
              as: Fragment,
              leave: "transition ease-in duration-100",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /*#__PURE__*/_jsx(Listbox.Options, {
                className: `absolute z-10 mt-1 ' ${props.style ? props.style : "max-h-56"}
                   w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`,
                children: props.payoutTokenOptions.filter(t => t.address.toLowerCase() !== NATIVE.toLowerCase()).map(token => !token.default && /*#__PURE__*/_jsx(Listbox.Option, {
                  className: _ref2 => {
                    let {
                      active
                    } = _ref2;
                    return classNames(active ? "text-white bg-indigo-600" : "text-gray-900", "relative cursor-default select-none py-2 pl-3 pr-9");
                  },
                  value: token,
                  "data-testid": "payout-token-option",
                  children: _ref3 => {
                    let {
                      selected,
                      active
                    } = _ref3;
                    return /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsxs("div", {
                        className: "flex items-center",
                        children: [token.icon ? /*#__PURE__*/_jsx("img", {
                          src: stringToBlobUrl(token.icon),
                          alt: "",
                          className: "h-4 w-4 md:h-6 md:w-6 flex-shrink-0 rounded-full"
                        }) : null, /*#__PURE__*/_jsx("span", {
                          className: classNames(selected ? "font-semibold" : "font-normal", "ml-3 block truncate"),
                          children: token.code
                        }), /*#__PURE__*/_jsx("span", {
                          className: "ml-3 text-sm text-gray-500",
                          children: props.balances && props.balances[token.address.toLowerCase()] && `Balance: ${Number(formatUnits(props.balances[token.address.toLowerCase()].value, props.balances[token.address.toLowerCase()].decimals)).toFixed(3)}`
                        })]
                      }), selected ? /*#__PURE__*/_jsx("span", {
                        className: classNames(active ? "text-white" : "text-indigo-600", "absolute inset-y-0 right-0 flex items-center pr-4"),
                        children: /*#__PURE__*/_jsx(CheckIcon, {
                          className: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      }) : null]
                    });
                  }
                }, token.code))
              })
            })]
          })
        });
      }
    })
  });
}